import React, { Fragment } from 'react';
import { IPostData } from '../../interfaces/post';
import ImageTitleDescHoriz from '../image/imageTitleDescHoriz';
interface IVideosChild {
    videos: IPostData[]
}
export default function VideosChild(props: IVideosChild) {
    return (
        <Fragment>
            {props?.videos?.map((data: IPostData) => (
                <ImageTitleDescHoriz data={data} isBigCard={false} />
            ))}
            {/* <div className="d-flex align-items-center flex-wrap flex-lg-nowrap pb-3 pb-lg-4 pb-xl-5">
                <a href="/#">
                    <img src="/assets/images/baseball5.jpg" alt="baseball" className="img-fluid" />
                </a>
                <div className="news-title">
                    <a href="/#" className="theme-white bold h6">MLB considering starting extra innings</a>
                    <p className="font-14 theme-white">Lorem ipsum dolor sit amet, consecte is adipiscing elit, sed do eiusc.</p>
                </div>
            </div> */}
        </Fragment>
    )
}
